const initialState = {
  issloadsim: false,
  shouldDownloadAfterRefresh: false,
  isNormalizeToggleOn: false,
  normalizeToggleInitialized: false,
  normalizeToggleByConfig: {},    // persists toggle state per simulation config (edition+cluster+fieldArray+store)
  activeNormalizeConfigKey: null, // current simulation config key
  dataPanelColumnSelections: {
    'product': {},
    'brand': {},
    'supplier': {},
    'category': {},
    'sub-category': {}
  },
  tabFilterSelections: {
    'product': [],
    'brand': [],
    'supplier': [],
    'category': [],
    'sub-category': []
  },
  tabSortConfig: {
    'product': { key: null, direction: 'desc' },
    'brand': { key: null, direction: 'desc' },
    'supplier': { key: null, direction: 'desc' },
    'category': { key: null, direction: 'desc' },
    'sub-category': { key: null, direction: 'desc' }
  }
};

export default function simulateAllReducer(state = initialState, action) {
  if (state && !state.dataPanelColumnSelections) {
    state = {
      ...state,
      dataPanelColumnSelections: initialState.dataPanelColumnSelections
    };
  }
  if (state && !state.tabFilterSelections) {
    state = {
      ...state,
      tabFilterSelections: initialState.tabFilterSelections
    };
  }
  if (state && !state.tabSortConfig) {
    state = {
      ...state,
      tabSortConfig: initialState.tabSortConfig
    };
  }

  switch (action.type) {
    case 'SET_ISSLOADSIM':
      return { ...state, issloadsim: action.payload };
    case 'SET_SHOULD_DOWNLOAD_AFTER_REFRESH':
      return { ...state, shouldDownloadAfterRefresh: action.payload };
    case 'SET_DATA_PANEL_COLUMN_SELECTION':
      return {
        ...state,
        dataPanelColumnSelections: {
          ...(state.dataPanelColumnSelections || initialState.dataPanelColumnSelections),
          [action.payload.tab]: action.payload.selections
        }
      };
    case 'SET_TAB_FILTER_SELECTIONS':
      return {
        ...state,
        tabFilterSelections: {
          ...(state.tabFilterSelections || initialState.tabFilterSelections),
          [action.payload.tab]: action.payload.selections
        }
      };
    case 'SET_TAB_SORT_CONFIG':
      return {
        ...state,
        tabSortConfig: {
          ...(state.tabSortConfig || initialState.tabSortConfig),
          [action.payload.tab]: action.payload.config
        }
      };
    case 'SET_NORMALIZE_TOGGLE_ON': {
      // Also persist the user's choice for the current active config key
      const byConfig = state.activeNormalizeConfigKey
        ? { ...(state.normalizeToggleByConfig || {}), [state.activeNormalizeConfigKey]: action.payload }
        : (state.normalizeToggleByConfig || {});
      return { ...state, isNormalizeToggleOn: action.payload, normalizeToggleByConfig: byConfig };
    }
    case 'SET_NORMALIZE_TOGGLE_INITIALIZED':
      return { ...state, normalizeToggleInitialized: action.payload };
    case 'SET_ACTIVE_SIMULATION_CONFIG': {
      const { configKey, defaultToggleValue } = action.payload;
      const byConfig = state.normalizeToggleByConfig || {};
      const stored = byConfig[configKey];
      // If user has previously set a value for this exact config, restore it; otherwise use preplan default
      const toggleValue = stored !== undefined ? stored : defaultToggleValue;
      return {
        ...state,
        activeNormalizeConfigKey: configKey,
        isNormalizeToggleOn: toggleValue,
        normalizeToggleByConfig: { ...byConfig, [configKey]: toggleValue },
      };
    }
    case 'RESET_NORMALIZE_CONFIG':
      return { ...state, normalizeToggleByConfig: {}, activeNormalizeConfigKey: null };
    default:
      return state;
  }
}
